// Module
var code = "<template> <section id=\"SignInView\" class=\"card material-card card-body h-100 d-flex align-items-center justify-content-center\"> </section> </template> ";
// Exports
export default code;